import styled from "styled-components";

export const PageContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    height: 100vh;
    align-items: center;
    justify-content: center;
    width: 23rem;
`